/* eslint-disable */
import { ISDSIcon } from "@sznds/icons";
import { ISDSIconMulti } from "~/interfaces";
import createSDSIcon from "~/ui/icon";
import { node, text } from "~/util/dom";

interface IMenuItem{
	title: string,
	icon: ISDSIcon | ISDSIconMulti,
	cb: () => void,
}

export default function createMenu(items: Array<IMenuItem>): HTMLUListElement {
	const menu = node("ul", { className: "context-menu" });

	for (let i = 0; i < items.length; i++ ) {
		let item = items[i];

		const li = node("li");

		li.append(createSDSIcon({
			symbol: item.icon,
		}), text(item.title));

		li.addEventListener("click", () => {
			item.cb();
		});

		menu.append(li);
	}

	return menu;
}
